import { styled, Tooltip } from '@mui/material';
import React from 'react';
import { useGetBpWithCustomCadrageNames } from '../hook';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@mui/icons-material/Error';

const StyErrorIcon = styled(ErrorIcon, {
    name: 'StyErrorIcon',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    fontSize: '1.3rem',
    marginLeft: '5px',
}));

const CustomCadrageBpsIndicator = ({
    exercice,
}: {
    exercice: number | null;
}): React.ReactElement => {
    const { t } = useTranslation();

    const { data: bpWithCustomCadrageNames } =
        useGetBpWithCustomCadrageNames(exercice);
    const formattedBpNames = bpWithCustomCadrageNames
        ?.map((name) => `\t${name}`)
        .join('\n');

    if (!bpWithCustomCadrageNames || bpWithCustomCadrageNames.length == 0)
        return <></>;
    return (
        <Tooltip
            title={
                <span style={{ whiteSpace: 'pre-wrap' }}>
                    {t(
                        'adminBudgetSpace.cadrage.customBudgetProposalsTooltip',
                        {
                            budgetProposals: formattedBpNames,
                        },
                    )}
                </span>
            }
            componentsProps={{
                tooltip: {
                    sx: {
                        maxWidth: '500px',
                    },
                },
            }}
        >
            <StyErrorIcon />
        </Tooltip>
    );
};

export default CustomCadrageBpsIndicator;
